import React, { useState, useEffect, useRef } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import axios from "axios";
import {
  Menu,
  Dropdown,
  Button,
  Space,
  Row,
  Col,
  Image,
  Typography,
  Checkbox,
  Form,
} from "antd";
import ReactToPrint from "react-to-print";
import { render } from "react-dom";
import { getLocalUrl } from "../../../functions";
import { getFileHostUrl } from "../../../helpers/functions";
import img from "../../../assets/images/logo.png";
import moment, { lang } from "moment";
import "../../../assets/styles/admin/printMedicine.scss";
import { string } from "prop-types";

interface Props {
  ComponentRef?: any;
  title?: string;
  dataOpdPrint?: any;
  type?: string;
  color?: string;
  nameTitle?: any;
  checkName?: string;
}

const PrintForMedicine: React.FC<Props> = ({
  ComponentRef,
  title,
  dataOpdPrint,
  type,
  color,
  nameTitle,
  checkName,
}) => {
  const componentRef = useRef<any>(ComponentRef);
  const { Text } = Typography;
  useEffect(() => {
    console.log("dataOpdPrint", dataOpdPrint);
  }, []);
  return (
    <div>
      {console.log("dataOpdPrint", dataOpdPrint)}
      <ReactToPrint
        trigger={() => (
          <Button
            style={{
              width: "100%",
              height: 50,
              background: color,
              borderRadius: 4,
              color: "white",
            }}
          >
            <Icon
              icon="ps:printer"
              width="1.2rem"
              height="1.2rem"
              style={{ marginRight: "8px", marginBottom: " 4px" }}
            />
            {title}
          </Button>
        )}
        content={() => componentRef.current}
        bodyClass="print-custom"
        // pageStyle="@page {size: 9cm 6cm}" //
        pageStyle="@page {size: A5}"
      />
      <>
        <div ref={componentRef} className="page-print-custom">
          <Row justify="center">
            <Col span={8}></Col>
            <Col span={8}>
              <Image
                preview={{ visible: false }}
                width={90}
                height={40}
                src={img}
                // onClick={() => setVisible(true)}
              />
            </Col>
            <Col span={8}>
              <Row justify="end">
                <Text style={{ fontSize: "8px", marginTop: "30px" }}>
                  {type === "medicine-thai" ? "วันที่ " : "Date "}
                  {moment().format("DD-MM-YYYY")}
                </Text>
              </Row>
            </Col>
          </Row>
          <Row justify="end">
            {/* {console.log("nameTitle=>>>>", nameTitle)} */}
            {checkName === "CustomerName" && (
              <Text style={{ fontSize: "8px", marginTop: "5px" }}>
                {type === "medicine-thai"
                  ? nameTitle?.prefix +
                    " " +
                    nameTitle?.dataName?.firstName +
                    " " +
                    nameTitle?.dataName?.lastName
                  : nameTitle?.prefix +
                    "" +
                    nameTitle?.dataName?.firstNameEN +
                    "" +
                    nameTitle?.dataName?.lastNameEN}
                {/* {dataOpdPrint[0]?.title === "CustomerName" ? nameTitle : ""} */}
              </Text>
            )}
          </Row>
          <Row justify="start" className="print-medical">
            <Text style={{ fontSize: "8px", marginTop: "5px" }}>
              {type === "medicine-thai" ? "ชื่อยา " : "Drug Name "}
              {dataOpdPrint[0]?.name}
            </Text>
          </Row>
          {!dataOpdPrint[0]?.vanishing && (
            <Row justify="start" className="print-medical">
              <Text style={{ fontSize: "8px", marginTop: "5px" }}>
                {type === "medicine-thai"
                  ? "รับประทานครั้งละ "
                  : "Take pill(s) per time "}
                {dataOpdPrint[0]?.Takepill &&
                  dataOpdPrint[0]?.Takepill + " " + dataOpdPrint[0]?.unit}
              </Text>
            </Row>
          )}

          {dataOpdPrint[0]?.PerDay && (
            <Row className="print-medical">
              <Text
                style={{
                  fontSize: "8px",
                  marginTop: "5px",
                }}
              >
                {type === "medicine-thai" ? "วันละ " : "Perday "}
                {dataOpdPrint[0]?.PerDay}
                {type === "medicine-thai" ? " ครั้ง " : " time"}
              </Text>
            </Row>
          )}
          <Row className="print-medical">
            {dataOpdPrint[0]?.BeforeMeal && (
              <Col span={6}>
                <Icon
                  icon="carbon:checkbox-checked"
                  color="#000000"
                  width="10"
                  height="10"
                />
                <Text className="text-medical">
                  {type === "medicine-thai" ? "ก่อนอาหาร" : "Before Meal "}
                </Text>
              </Col>
            )}
            {dataOpdPrint[0]?.afterMeal && (
              <Col span={6}>
                <Icon
                  icon="carbon:checkbox-checked"
                  color="#000000"
                  width="10"
                  height="10"
                />
                <Text className="text-medical">
                  {type === "medicine-thai" ? "หลังอาหาร" : "After Meal "}
                </Text>
              </Col>
            )}
          </Row>
          <Row className="print-medical">
            {dataOpdPrint[0]?.morning && (
              <Col span={6}>
                <Icon
                  icon="carbon:checkbox-checked"
                  color="#000000"
                  width="10"
                  height="10"
                />
                <Text className="text-medical">
                  {type === "medicine-thai" ? "เช้า" : "Breakfast"}
                </Text>
              </Col>
            )}
            {dataOpdPrint[0]?.noon && (
              <Col span={6}>
                <Icon
                  icon="carbon:checkbox-checked"
                  color="#000000"
                  width="10"
                  height="10"
                />
                <Text className="text-medical">
                  {type === "medicine-thai" ? "กลางวัน" : "Lunch"}
                </Text>
              </Col>
            )}
            {dataOpdPrint[0]?.evening && (
              <Col span={6}>
                <Icon
                  icon="carbon:checkbox-checked"
                  color="#000000"
                  width="10"
                  height="10"
                />
                <Text className="text-medical">
                  {type === "medicine-thai" ? "เย็น" : "Dinner"}
                </Text>
              </Col>
            )}
            {dataOpdPrint[0]?.bedtime && (
              <Col span={6}>
                <Icon
                  icon="carbon:checkbox-checked"
                  color="#000000"
                  width="10"
                  height="10"
                />
                <Text className="text-medical">
                  {type === "medicine-thai" ? "ก่อนนนอน" : "Night"}
                </Text>
              </Col>
            )}
          </Row>
          <Row className="line-title-meidicine"></Row>
          <Row justify="center">
            <Text style={{ fontSize: "6px" }}>
              สาขา เอกมัย - 342 ซอยสุขุมวิท 63 (เอกมัย) ระหว่างซอยเอกมัย 18-20
              แขวงคลองตันเหนือ เขตวัฒนา กรุงเทพ ฯ 10110
            </Text>
            <Text style={{ fontSize: "6px" }}>
              โทร 02 71-444-71 แฟกซ์ 02-714-4001
            </Text>
          </Row>
        </div>
      </>
    </div>
  );
};

export default PrintForMedicine;
